import { AllowArrayInCompanyId } from "Util/allowArrayInCompanyId";
import { Team } from "../models/team";
import BaseService from "./_base.service";

const endpoint = "teams";

const TeamsService = {
  ...BaseService<AllowArrayInCompanyId<Team>, Team>({ endpoint })
};

export default TeamsService;
